import api from './api';

export interface PlanEntitlements {
  videoProcessingHoursPerMonth: number;
  videoTranslationsPerMonth: number;
  audioTranslationsPerMonth: number;
  speechToTextMinutesPerMonth: number;
  textToSpeechCharactersPerMonth: number;
  clipsPerMonth: number;
  connectedAccountsLimit: number;
  translationLanguagesTier?: '50+' | '100+';
  voiceCloning: boolean;
  lipSync: boolean;
  thumbnailGenerator: boolean;
  schedulingCalendar: boolean;
  analyticsDashboard: boolean;
  clientWorkspaces: number;
  approvalWorkflows: boolean;
  brandKits: boolean;
  prioritySupport: boolean;
  apiAccess: boolean;
  ssoSaml: boolean;
  customAiModels: boolean;
  maxTeamMembers: number;
  maxVoices: number;
  maxAvatars: number;
  maxProjects: number;
}

export interface Plan {
  key: string;
  name: string;
  description?: string;
  monthlyPriceUsd?: number;
  yearlyPriceUsd?: number;
  isCustomPricing: boolean;
  mostPopular: boolean;
  entitlements: PlanEntitlements;
}

export interface UsageCounts {
  videoTranslations: number;
  audioTranslations: number;
  speechToTextMinutes: number;
  textToSpeechCharacters: number;
  clips: number;
  connectedAccounts: number;
  projects: number;
  teamMembers: number;
  voices: number;
  avatars: number;
}

export interface SubscriptionWithUsage {
  plan: string;
  planName: string;
  status: 'trial' | 'active' | 'past_due' | 'cancelled' | 'expired' | 'inactive';
  isActive: boolean;
  trialEndsAt?: string;
  currentPeriodStart?: string;
  currentPeriodEnd?: string;
  cancelAtPeriodEnd: boolean;
  entitlements: PlanEntitlements;
  usage: UsageCounts;
}

const billingApi = {
  getPlans: () => api.get<{ success: boolean; plans: Plan[] }>('/billing/plans'),

  getSubscription: () =>
    api.get<{ success: boolean; subscription: SubscriptionWithUsage }>('/billing/subscription'),

  createCheckoutSession: (plan: string, billingCycle: 'monthly' | 'yearly' = 'monthly') =>
    api.post<{ success: boolean; checkoutUrl: string; sessionId: string }>('/billing/checkout', {
      plan,
      billingCycle,
    }),

  createPortalSession: () =>
    api.post<{ success: boolean; portalUrl: string }>('/billing/portal'),

  cancelSubscription: () => api.post<{ success: boolean; message: string }>('/billing/cancel'),

  reactivateSubscription: () => api.post<{ success: boolean; message: string }>('/billing/reactivate'),
};

export default billingApi;
